/* Scoped exact-asset localization. No mirror, text, prices, forms or cart mutation. */
(function(){
  'use strict';
  var config=window.mstLocaleImages;
  if(!config || !config.images)return;
  var map=config.images, roots=new WeakSet();
  function entry(url){
    try{
      var u=new URL(url,location.href);
      if(!/(^|\.)(shopify\.com|mistly\.co\.il|mistlycare\.com|myshopify\.com)$/.test(u.hostname))return null;
      var name=decodeURIComponent(u.pathname.split('/').pop());
      return map[name]||map[name.replace(/_\d+x\d*(?:_crop_[a-z]+)?(?=\.[^.]+$)/,'')]||null;
    }catch(e){return null;}
  }
  function swapURL(url){var e=entry(url);return e&&e.url?e.url:url;}
  function swapSet(value){return value.split(',').map(function(item){var p=item.trim().split(/\s+/);p[0]=swapURL(p[0]);return p.join(' ');}).join(', ');}
  function attr(el,key,fn){var old=el.getAttribute(key);if(!old)return;var next=fn(old);if(next!==old)el.setAttribute(key,next);}
  function one(el){
    if(el.nodeType!==1)return;
    if(el.tagName==='IMG'){
      var e=entry(el.getAttribute('src')||el.getAttribute('data-src')||'');
      ['src','data-src','data-original','data-zoom'].forEach(function(a){attr(el,a,swapURL);});
      ['srcset','data-srcset'].forEach(function(a){attr(el,a,swapSet);});
      if(e&&e.alt)el.setAttribute('alt',e.alt);
    }
    if(el.tagName==='SOURCE'&&el.parentElement&&el.parentElement.tagName==='PICTURE'){
      ['srcset','data-srcset'].forEach(function(a){attr(el,a,swapSet);});
    }
    if(el.tagName==='A')attr(el,'href',swapURL);
    // Only exact image URLs, including Shopify Forms' existing shadow-DOM background.
    if(el.hasAttribute('style'))attr(el,'style',function(s){return s.replace(/url\((['"]?)(.*?)\1\)/g,function(all,q,u){var next=swapURL(u);return next===u?all:'url("'+next+'")';});});
    if(el.shadowRoot)watch(el.shadowRoot);
  }
  function scan(root){one(root);if(root.querySelectorAll)root.querySelectorAll('img,source,a,[style],shopify-forms-embed').forEach(one);}
  function watch(root){
    if(roots.has(root))return;roots.add(root);scan(root);
    new MutationObserver(function(records){records.forEach(function(r){if(r.type==='attributes')one(r.target);else r.addedNodes.forEach(scan);});}).observe(root,{childList:true,subtree:true,attributes:true,attributeFilter:['src','srcset','data-src','data-srcset','style','href']});
  }
  watch(document.documentElement);
  // Forms can attach a shadowRoot after the host is inserted, without a DOM mutation.
  var tries=0,timer=setInterval(function(){document.querySelectorAll('shopify-forms-embed').forEach(one);if(++tries>=120)clearInterval(timer);},500);
  document.addEventListener('DOMContentLoaded',function(){scan(document.documentElement);},{once:true});
})();
